import type { UserGuidedTourType } from 'constants/user-guided-tour-type';
import { createAction, type ActionsUnion } from 'store/helper';

export enum UserGuidedTourActionNames {
  TOUR_READY = 'FEATURES/USER_GUIDED_TOUR/TOUR_READY',
  SHOW_TOUR = 'FEATURES/USER_GUIDED_TOUR/SHOW_TOUR',
  HIDE_TOUR = 'FEATURES/USER_GUIDED_TOUR/HIDE_TOUR',
  SET_TOUR_STEP = 'FEATURES/USER_GUIDED_TOUR/SET_TOUR_STEP',
  RESET_TOUR = 'FEATURES/USER_GUIDED_TOUR/RESET_TOUR',
}

export const UserGuidedTourActions = {
  tourReady: (tourId: UserGuidedTourType, isReady: boolean) =>
    createAction(UserGuidedTourActionNames.TOUR_READY, { tourId, isReady }),
  showTour: (tourId: UserGuidedTourType) => createAction(UserGuidedTourActionNames.SHOW_TOUR, { tourId }),
  hideTour: (tourId: UserGuidedTourType) => createAction(UserGuidedTourActionNames.HIDE_TOUR, { tourId }),
  setTourStep: (tourId: UserGuidedTourType, step: number) =>
    createAction(UserGuidedTourActionNames.SET_TOUR_STEP, { tourId, step }),
  resetTour: (tourId: UserGuidedTourType) => createAction(UserGuidedTourActionNames.RESET_TOUR, { tourId }),
};

export type UserGuidedTourActionType = ActionsUnion<typeof UserGuidedTourActions>;
